import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { CartProductTrackingInfo } from "@services/tracking/types/trackingInfo/cartProductTrackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo,
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct,
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsAddToCartImpression
    extends GoogleAnalyticsMinimumDataset {
    ecommerce: {
        currencyCode: string;
        add: {
            products: GoogleAnalyticsProduct[];
        };
    };
}

const getGoogleAnalyticsAddToCartImpression = (
    data: TypedAnalyticsEvent<CartProductTrackingInfo>,
): GoogleAnalyticsAddToCartImpression => {
    const googleAnalyticsCommerce: GoogleAnalyticsProduct =
        getGoogleAnalyticsProduct(data.payload.eventData);

    return {
        event: GoogleAnalyticsEvents.ProductAddToCart,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        ecommerce: {
            currencyCode: data.payload.eventData.currencyCode,
            add: {
                products: [
                    {
                        ...googleAnalyticsCommerce,
                        quantity: data.payload.eventData.quantity,
                    },
                ],
            },
        },
    };
};

export { getGoogleAnalyticsAddToCartImpression };
